import Vue from 'vue'
import Router from "vue-router";
import main from '@/views/main'

Vue.use(Router)

const routes = [
    { path: "/", redirect: "/home" },
    {
        path: "/mobileCardList",
        name: "mobileCardList",
        component: (resolve) => require(['@/pages/certifitalViewPhone/mobileCardList.vue'], resolve),
    },
    {
        path: "/mobileCertificateView",
        name: "mobileCertificateView",
        component: (resolve) => require(['@/pages/certifitalViewPhone/mobileCertificateView.vue'], resolve),
    },
    {
        path: "/main",
        name: "main",
        component: main,
        children:[{
                path: "/home",
                name: "home",
                component: (resolve) => require(['@/views/home'], resolve),
                meta:{
                    index:1
                }
            },
            {
                path: "/depositCertificateFormula",
                name: "depositCertificateFormula",
                component: (resolve) => require(['@/views/depositCertificateFormula'], resolve),
                meta:{
                    index:2
                }
            },
            {
                path: "/registerCertificateFormula",
                name: "registerCertificateFormula",
                component: (resolve) => require(['@/views/registerCertificateFormula'], resolve),
                meta:{
                    index:3
                }
            },
            {
                path: "/infoPublic",
                name: "infoPublic",
                component: (resolve) => require(['@/views/infoPublic'], resolve),
                meta:{
                    index:4
                }
            },
            {
                path: "/putonRecordDetialCertical",
                name: "putonRecordDetialCertical",
                component: (resolve) => require(['@/views/putonRecordDetial-certical'], resolve)
            },
            {
                path: "/putonRecordDetialRegister",
                name: "putonRecordDetialRegister",
                component: (resolve) => require(['@/views/putonRecordDetial-register'], resolve)
            },
            {
                path: "/certificateDetial",
                name: "certificateDetial",
                component: (resolve) => require(['@/views/certificateDetial'], resolve),
            },
            {
                path: "/registerDetial",
                name: "registerDetial",
                component: (resolve) => require(['@/views/registerDetial'], resolve),
                
            },
            {
                path: "/cancelDetialCertical",
                name: "cancelDetialCertical",
                component: (resolve) => require(['@/views/cancelDetial-certical'], resolve),
                
            },   
            {
                path: "/changeDetialCertical",
                name: "changeDetialCertical",
                component: (resolve) => require(['@/views/changeDetial-certical'], resolve),
                
            },
            {
                path: "/changeDetialRegister",
                name: "changeDetialRegister",
                component: (resolve) => require(['@/views/changeDetial-register'], resolve),
                
            },
            {
                path: "/cancelDetialRegister",
                name: "cancelDetialRegister",
                component: (resolve) => require(['@/views/cancelDetial-register'], resolve),
                
            },
            {
                path: "/question",
                name: "question",
                component: (resolve) => require(['@/views/question'], resolve),
                meta:{
                    index:6
                }
                
            },
            {
                path: "/correctError",
                name: "correctError",
                component: (resolve) => require(['@/views/correctError'], resolve),
                meta:{
                    index:5
                }
                
            },
            {
                path: "/correctErrorDetialRegister",
                name: "correctErrorDetialRegister",
                component: (resolve) => require(['@/views/correctErrorDetial-register'], resolve),
                
            },
            {
                path: "/correctErrorDetialCertical",
                name: "correctErrorDetialCertical",
                component: (resolve) => require(['@/views/correctErrorDetial-certical'], resolve),
                
            },
            
            {
                path: "/operationRedirect",
                name: "operationRedirect",
                component: (resolve) => require(['@/views/operationRedirect'], resolve),
                meta:{
                    index:7
                }
                
                
            },
            {
                path: "/transactionUsage",
                name: "transactionUsage",
                component: (resolve) => require(['@/views/transactionUsage'], resolve),
                meta:{
                    index:8
                }
                
                
            }
            
        ]
    },
    
]
export default new Router({
    mode: 'hash', // 去掉url中的#
    scrollBehavior: () => ({ y: 0 }),
    routes: routes
})